import { render, staticRenderFns } from "./PolizasSGCard.vue?vue&type=template&id=2caf327e&scoped=true&"
import script from "./PolizasSGCard.vue?vue&type=script&lang=js&"
export * from "./PolizasSGCard.vue?vue&type=script&lang=js&"
import style0 from "./PolizasSGCard.vue?vue&type=style&index=0&id=2caf327e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf327e",
  null
  
)

export default component.exports